import { debounce } from './helpers';

export const viewport = () => {
  return {
    breakpoint: 'sm',

    init() {
      this.setBreakpoint();

      window.addEventListener('resize', debounce(this.setBreakpoint));
    },

    setBreakpoint() {
      if (window.innerWidth <= 767) {
        this.breakpoint = 'sm';
      } else if (window.innerWidth <= 1023) {
        this.breakpoint = 'md';
      } else if (window.innerWidth <= 1279) {
        this.breakpoint = 'lg';
      } else {
        this.breakpoint = 'xl';
      }

      window.dispatchEvent(
        new CustomEvent('viewport-changed', {
          detail: {
            size: this.breakpoint,
          },
        }),
      );
    },
  };
};
